var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4H35C35.3315 4 35.6494 4.13179 35.8838 4.36621C36.1182 4.60063 36.25 4.91848 36.25 5.25V11.6182L33.75 14.1182V6.5H8.25V35.5H33.75V30.3809L36.25 27.8809V36.75C36.25 37.0815 36.1182 37.3994 35.8838 37.6338C35.6494 37.8682 35.3315 38 35 38H7C6.66848 38 6.35063 37.8682 6.11621 37.6338C5.88179 37.3994 5.75 37.0815 5.75 36.75V5.25C5.75 4.91848 5.88179 4.60063 6.11621 4.36621C6.32122 4.1612 6.58999 4.03436 6.87598 4.00586L7 4ZM39.8789 17.8887L26.7676 30.999L24.9961 30.9961L24.999 29.2324L38.1113 16.1211L39.8789 17.8887ZM22.25 21.5V24H14.5V21.5H22.25ZM27.5 14.5V17H14.5V14.5H27.5Z",
    fill: "#C0C0C0",
    stroke: "#C0C0C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.efdcb8e3eeadcadfbdd498cf554104f2.svg";
export { ForwardRef as ReactComponent };